import React, { useState, useEffect } from 'react';
import { adminApi } from '../../api/admin';
import { Activity, AlertCircle } from 'lucide-react';

const AdminScores = () => {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [gameweekId, setGameweekId] = useState('');

  useEffect(() => {
    if (gameweekId) {
      loadScores();
    } else {
      setScores([]);
      setLoading(false);
    }
  }, [gameweekId]);

  const loadScores = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await adminApi.getRawScores(parseInt(gameweekId));
      if (response?.success) {
        setScores(response.scores || []);
      } else {
        setScores([]);
      }
    } catch (err) {
      console.error('Error loading scores:', err);
      setError(err.message || 'Failed to load scores');
      setScores([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold flex items-center">
          <Activity className="w-8 h-8 mr-3 text-green-400" />
          Scores & Results
        </h1>
      </div>

      <div className="bg-gray-800 rounded-lg p-6 mb-6 border border-gray-700">
        <label className="block text-gray-300 mb-2">GameWeek ID</label>
        <input
          type="number"
          value={gameweekId}
          onChange={(e) => setGameweekId(e.target.value)}
          placeholder="Enter GameWeek ID"
          className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white"
        />
      </div>

      {error && (
        <div className="bg-red-900/50 border border-red-500 rounded-lg p-4 mb-6 flex items-center space-x-2">
          <AlertCircle className="w-5 h-5 text-red-400" />
          <p className="text-red-400">{error}</p>
        </div>
      )}

      {loading ? (
        <div className="text-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400 mx-auto"></div>
          <p className="mt-4 text-gray-400">Loading scores...</p>
        </div>
      ) : scores.length === 0 ? (
        <div className="text-center py-12 text-gray-400">
          {gameweekId ? 'No scores found for this GameWeek' : 'Enter a GameWeek ID to view scores'}
        </div>
      ) : (
        <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-700">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold">Player</th>
                <th className="px-4 py-3 text-left text-sm font-semibold">Score</th>
                <th className="px-4 py-3 text-left text-sm font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {scores.map((score, idx) => (
                <tr key={idx} className="border-t border-gray-700">
                  <td className="px-4 py-3">{score.player_name || 'N/A'}</td>
                  <td className="px-4 py-3">{score.score || 0}</td>
                  <td className="px-4 py-3">{score.status || 'pending'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminScores;

